export default __webpack_public_path__ + "static/media/dawiyat.b835badf.png";